import en from './en.json'
import it from './it.json'

export const arrivalsTranslations = {
	en,
	it
} as const
